// AI-CONTEXT: See docs/features/livereport2-period-selector.md
//
// Resolves the effective date range for a LiveReport2 data widget from its
// own period setting and the report's overall period.
//
// Widget modes:
//   'inherit' — follow the report's overall period (default)
//   'custom'  — use the widget's own start/end
//   'all'     — explicitly no filter, even when the report has a period
//
// Legacy values without a `mode` (pre-migration HouseVisits dateRange):
// empty = inherit, with dates = custom. Safe because no report had an
// overall period before this feature existed.

/**
 * @typedef {object} PeriodRange
 * @property {string|null} start - ISO date 'YYYY-MM-DD' or null (unbounded)
 * @property {string|null} end - ISO date 'YYYY-MM-DD' or null (unbounded)
 */

/**
 * @param {{mode?: 'inherit'|'custom'|'all', start?: string|null, end?: string|null}|null|undefined} widgetValue - The widget's saved period setting
 * @param {PeriodRange|null} overallPeriod - The report's overall period, or null when none is set
 * @returns {PeriodRange|null} The range to filter on, or null for no filter
 */
const resolveWidgetPeriod = (widgetValue, overallPeriod) => {
    const asRangeOrNull = (range) => {
        const start = range?.start || null
        const end = range?.end || null
        return (start || end) ? { start, end } : null
    }

    const mode = widgetValue?.mode
        || ((widgetValue?.start || widgetValue?.end) ? 'custom' : 'inherit')

    if (mode === 'all') return null
    if (mode === 'custom') return asRangeOrNull(widgetValue)
    return asRangeOrNull(overallPeriod)
}

export default resolveWidgetPeriod
